// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueFire from 'vuefire'
require('./assets/css/main.css');

Vue.config.productionTip = false
Vue.use(VueFire)

// Vue bootstrap
// Vue.use(BootstrapVue);
// require('../node_modules/bootstrap-vue/dist/bootstrap-vue.css');
// require('../node_modules/bootstrap/dist/css/bootstrap.css');

// Vue2 Filters
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

// Jquery and Bootstrap added here
window.$ = window.jQuery = require('jquery');
require('bootstrap');

export const eventBus = new Vue();

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App },
})


// WEBPACK FOOTER //
// ./src/main.js